import React from 'react';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { useTheme } from 'styled-components';
import { CustomSwitch, PromotionSwitchHolder, PromotionWrapper, PromotioSwitchText } from '../styledComponents';

const PromotionSection = props => {
  const { Account } = useTheme();
  const { handle, value } = props;

  return (
    <PromotionWrapper>
      <PromotioSwitchText onClick={handle} theme={Account.Label} enabled={value}>
        {getText(TEXT_KEY.PROMOTIONAL_EMAIL_OPTION)}
      </PromotioSwitchText>
      <PromotionSwitchHolder>
        <CustomSwitch className="custom-switch">
          <>
            <input type="checkbox" checked={value} readOnly />
            <span className="slider" onClick={handle} />
          </>
        </CustomSwitch>
      </PromotionSwitchHolder>
    </PromotionWrapper>
  );
};
export default PromotionSection;

